import utils from '../../utils';
import '../style-box';
import '../star-rating';
import '../checkbox/';
import '../button-group/';

const BTN_ONLY = '__button--icon-only';
const BTN_SMALL = '__button--small';
function getFormatValue({ formatter, value, dataType, column, row = {} } = {}) {
    if (row.subs && row.subs.length) {
        return '';
    }
    return utils.getFormatValue({
        formatter,
        value,
        dataType: dataType || column.dataType,
        listedCurrency: row['listedCurrency']
    });
}

function getUpDownFormatValue({
    formatter,
    value,
    row = {},
    column,
    namespace,
    reverse = false
} = {}) {
    if (row.subs && row.subs.length) {
        return '';
    }
    let d;
    if (typeof value === 'undefined' || value === null) {
        return utils.emptyString;
    }
    d = getFormatValue({
        formatter,
        dataType: 'number',
        value,
        column,
        row
    });
    if (d !== '') {
        let suffix;
        if (value > 0) {
            d = `+${d}`;
            suffix = reverse ? 'negative' : 'positive';
        } else if (value < 0) {
            suffix = reverse ? 'positive' : 'negative';
        } else {
            suffix = 'neutral';
        }
        const style = namespace(`__${suffix}`);
        d = `<span class="${style}">${d}</span>`;
    }
    return d;
}
/**
 * Format updown value with a up or down arrow icon
 * @param {object} params - parameters collection
 * @param {object} params.formatter - farmat object
 * @param {value} params.value - value to format
 * @param {function} params.namespace - a function to namespace the class
 * @param {boolean} params.namespaced - indicate if need mds version namespace
 */
function upDownWithIconFormatValue({
    formatter,
    value,
    column,
    row = {},
    namespace,
    namespaced
}) {
    let icon = '',
        cls = '',
        iconString = '';
    if (value > 0) {
        icon = '#performance-arrow-up';
        cls = namespace('__positive');
    } else if (value < 0) {
        icon = '#performance-arrow-down';
        cls = namespace('__negative');
    }
    if (icon) {
        iconString = getIconFormatValue({
            namespaced,
            cls: `${namespace(BTN_ONLY)} ${namespace(BTN_SMALL)}`,
            svgCls: `${namespace('__icon')} ${cls}`
        })(icon);
    }
    return (
        iconString +
        getUpDownFormatValue({
            formatter,
            value,
            column,
            row,
            namespace
        })
    );
}
export function getIconFormatValue({ namespaced, cls = '', svgCls = '' }) {
    return value => {
        const spanCls = `${utils.mdsNS(
            'button--icon-only button--small',
            namespaced
        )} ${cls}`;
        svgCls =
            utils.mdsNS('icon button__icon', namespaced) +
            (svgCls ? ` ${svgCls}` : '');
        return `<span type="button" class="${spanCls}">
                <svg aria-hidden="true" class="${svgCls}" pointer-events="none">
                    <use xlink:href="${value}"></use>
                </svg>
            </span>`;
    };
}
function getOtherDataFormatter({ dataType, namespaced, namespace, skin }) {
    let format;
    switch (dataType) {
        case 'checkbox':
            format = (value, rowData = {}) => {
                return `<markets-ui-checkbox skin="${skin}" namespaced="${namespaced}" checked="${value}" value="${rowData.id ||
                    ''}" ></markets-ui-checkbox>`;
            };
            break;
        case 'styleBox':
            format = value => {
                return `<markets-ui-style-box skin="${skin}" value="${value}" namespaced="${namespaced}"></markets-ui-style-box>`;
            };
            break;
        case 'starRating':
            format = value => {
                return `<markets-ui-star-rating skin="${skin}" value="${value}" namespaced="${namespaced}"></markets-ui-star-rating>`;
            };
            break;
        case 'buttonGroup':
            format = value => {
                return `<markets-ui-button-group data-model="${JSON.stringify(
                    value
                )}" ></markets-ui-button-group>`;
            };
            break;
        case 'icon':
            format = value => {
                if (value) {
                    return getIconFormatValue({
                        namespaced,
                        cls: `${namespace(BTN_ONLY)} ${namespace(BTN_SMALL)}`,
                        svgCls: namespace('__icon')
                    })(value);
                } else {
                    return '';
                }
            };
            break;
        case 'tree':
            format = value => {
                const textCls = namespace('__text-hover');
                const iconStr = getIconFormatValue({
                    namespaced,
                    cls: `${namespace(BTN_ONLY)} ${namespace(
                        BTN_SMALL
                    )} ${namespace('__button--icon-only-hover')}`,
                    svgCls: namespace('__icon')
                })('#caret-circle-down--s');
                return `<span class="${textCls}">${value}</span>${iconStr}`;
            };
            break;
        case 'search':
            format = (value, rowData) => {
                const cls = `${utils.mdsNS(
                    'form__input',
                    namespaced
                )} ${namespace('__input')}`;
                const svgCls = `${utils.mdsNS('icon', namespaced)} ${namespace(
                    '__icon--search'
                )}`;
                return `<input type="text" class="${cls}" id='${rowData.inputId ||
                    ''}' value='${value || ''}' autocomplete="off" >
                        <svg class="${svgCls} " aria-hidden="true">
                            <use xlink:href="#search--s">
                            </use>
                        </svg>`;
            };
            break;
        default:
            format = value => {
                return value;
            };
            break;
    }
    return format;
}
//in order to comply with eslint rules, this function has been broken down into two.
export function getDataFormatter({
    formatter,
    dataType,
    namespaced,
    namespace,
    skin
}) {
    let format;
    switch (dataType) {
        case 'string':
        case 'number':
        case 'int':
        case 'abbreviate':
        case 'intAbbreviation':
        case 'date':
        case 'time':
        case 'withCurrency':
            format = (value, rowData, column) => {
                return getFormatValue({
                    formatter,
                    value,
                    column,
                    row: rowData
                });
            };
            break;
        case 'dateTime':
            format = (value, rowData, column) => {
                let d = getFormatValue({
                    formatter,
                    value,
                    column,
                    row: rowData
                });
                if (
                    d !== '' &&
                    d !== utils.emptyString &&
                    rowData.localTimeZone
                ) {
                    d = `${d} ${rowData.localTimeZone}`;
                }
                return d;
            };
            break;
        case 'upDown':
            format = (value, rowData, column) => {
                return getUpDownFormatValue({
                    formatter,
                    value,
                    column,
                    row: rowData,
                    namespace
                });
            };
            break;
        case 'upDownWithIcon':
            format = (value, rowData, column) => {
                return upDownWithIconFormatValue({
                    formatter,
                    value,
                    column,
                    row: rowData,
                    namespace,
                    namespaced
                });
            };
            break;
        case 'bargain':
            format = (value, rowData, column) => {
                return getUpDownFormatValue({
                    formatter,
                    value,
                    column,
                    row: rowData,
                    namespace,
                    reverse: true
                });
            };
            break;
        default:
            format = getOtherDataFormatter({
                dataType,
                namespaced,
                namespace,
                skin
            });
    }
    return format;
}
